<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify" /> Créer un nouvel utilisateur</strong>
          </div>
          <b-form>
            <b-form-group label="Nom" label-for="basicName">
              <b-form-input
                id="basicName"
                type="text"
                autocomplete="name"
                :class="{hasError: errors.nom !== ''}"
                v-model="nom"
              />
              <span class="field-error">{{ errors.nom }}</span>
            </b-form-group>

            <b-form-group label="Prénom" label-for="basicText">
              <b-form-input
                id="basicText"
                type="text"
                :class="{hasError: errors.prenom !== ''}"
                v-model="prenom"
              />
              <span class="field-error">{{ errors.prenom }}</span>
            </b-form-group>

            <b-form-group label="Email" label-for="basicEmail">
              <b-form-input
                id="basicEmail"
                type="email"
                autocomplete="email"
                :class="{hasError: errors.email !== ''}"
                v-model="email"
              />
              <span class="field-error">{{ errors.email }}</span>
              <span class="field-error">{{ validationErrors.email }}</span>
            </b-form-group>

            <b-form-group label="Structure" label-for="basicSelect">
              <b-form-select v-model="selectedStructure" :options="structuresOptions">
              </b-form-select>
              <span class="field-error">{{ errors.structure }}</span>
            </b-form-group>

            <b-row>
                <b-col sm="4">
                    <b-form-group label="Profil" label-for="basicSelect">
                    <b-form-select
                        id="basicSelect"
                        :plain="true"
                        :options="profilsOptions"
                        v-model="selectedProfil"
                    />
                    </b-form-group>
                    <span class="field-error">{{ errors.profil }}</span>
                </b-col>
                <b-col sm="4">
                    <b-form-group label="N° User NSI" label-for="basicText">
                        <b-form-input
                            id="basicText"
                            type="text"
                            placeholder=""
                            :class="{hasError: errors.nsi_numero_user !== ''}"
                            v-model="nsi_numero_user"
                        ></b-form-input>
                        <span class="field-error">{{ errors.nsi_numero_user }}</span>
                    </b-form-group>
                </b-col>
                <b-col sm="4">
                    <b-form-group label="N° Acteur NSI" label-for="basicText">
                        <b-form-input
                            id="basicText"
                            type="text"
                            placeholder=""
                            :class="{hasError: errors.nsi_numero_acteur !== ''}"
                            v-model="nsi_numero_acteur"
                        ></b-form-input>
                        <span class="field-error">{{ errors.nsi_numero_acteur }}</span>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
              <b-col sm="4">
                <b-form-group>
                  <label for="date_debut"><strong>Date début</strong></label>
                    <b-form-input type="date" id="date_debut" v-model="dateDebut"></b-form-input>
                    <span class="field-error">{{ errors.dateDebut }}</span>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group>
                  <label for="date_fin"><strong>Date fin</strong></label>
                    <b-form-input type="date" id="date_fin" v-model="dateFin"></b-form-input>
                    <span class="field-error">{{ errors.dateFin }}</span>
                </b-form-group>
              </b-col>
            </b-row>
            <div slot="footer">
              <b-button type="button" @click="returnBack" size="md" variant="secondary">
                <i class="fa fa-arrow-left"/> Liste des utilisateurs
              </b-button>
              <b-button type="button" @click="saveUser" size="md" class="pull-right" variant="primary">
                <i class="fa fa-save"/> Enregistrer
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '../../../utils/auth'
import {en, fr} from 'vuejs-datepicker/dist/locale'

export default {
  name: 'CreateUser',
  data() {
    return {
      nom: "",
      prenom: "",
      email: "",
      structure: "",
      structuresOptions: [],
      selectedStructure: "",
      profils: [],
      profilsOptions: [],
      selectedProfil: "",
      nsi_numero_user: "",
      nsi_numero_acteur: "",
      errors: {
        nom: "",
        prenom: "",
        email: "",
        structure: "",
        profil: "",
        nsi_numero_user: "",
        nsi_numero_acteur: "",
        dateDebut: '',
        dateFin: '',
      },
      dateDebut: '',
      dateFin: '',
      validationErrors: {
        email: ""
      },
      fr: fr,
      DatePickerFormat: 'dd/MM/yyyy'
    }
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();
    this.allHabilitations();
    this.getStructures();
  },
  watch: {
    selectedStructure: function() {
      if (this.selectedStructure) {
        // Si la structure change on vide le profil précédemment sélectionné et on recalcul le select des profils
        this.selectedProfil = '';
        this.setProfilOptions();
      } else {
        this.profilsOptions = [];
        this.selectedProfil = '';
      }
    },
  },
  methods: {
    allHabilitations() {
      // Récupérer la liste de tous les profils
      this.$axios
        .get("/administration/profiles")
        .then(response => {
          this.profils = response.data.profils;

          // for (var i = 0; i < profils.length; i++) {
          //   this.profilsOptions.push({
          //     text: profils[i].libelle,
          //     value: profils[i].id
          //   });
          // }
        })
        .catch(function(error) {});
    },
    getStructures() {
      this.$axios
        .get("/administration/structures")
        .then(response => {
          for(let structures of response.data.structures){
            this.structuresOptions.push({value: structures.id, text: structures.libelle})
          }
        })
        .catch(() => {
          this.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Un probléme est survenue, merci de contacter l\'administrateur',
            showConfirmButton: false,
            timer: 5000
          })
        });
    },
    setProfilOptions() {
      this.profilsOptions = [];
      for (let profil of this.profils) {
        if (profil.structures.map(structure => structure.id).indexOf(this.selectedStructure) > -1) {
          this.profilsOptions.push({value: profil.id, text: profil.libelle});
        }
      }
    },
    saveUser() {
      if (this.validateData()) {
        this.$store.commit("IS_LOADING", true);
        let self = this;
        let dataPost = {};

        dataPost.nom = this.nom;
        dataPost.prenom = this.prenom;
        dataPost.email = this.email;
        dataPost.structure_id = this.selectedStructure;
        dataPost.profil = this.selectedProfil;
        dataPost.nsi_numero_acteur = this.nsi_numero_acteur;
        dataPost.nsi_numero_user = this.nsi_numero_user;
        dataPost.dateDebut = this.dateDebut;
        dataPost.dateFin = this.dateFin;

        this.$axios
          .post("/administration/users", dataPost)
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            this.$swal({
              position: "top",
              type: "success",
              title: "Création avec succès",
              text: "L'utilisateur " + dataPost.prenom + ' ' + dataPost.nom + " a bien été créé",
              showConfirmButton: false,
              timer: 5000
            });
            this.returnBack()
          })
          .catch(function(error) {
            self.$store.commit("IS_LOADING", false);
            // console.log(error.response)
            if (error.response.status == 422 && error.response.data.errors){
              //self.validationErrors = error.response.data.errors.email;
              self.validationErrors.email = "Cette adresse email est déjà utilisée.";
            } else if(error.response && error.response.status == 403) {
              self.$swal({
                position: "top",
                type: "warning",
                title: "Attention !!",
                text: error.response.data.message,
                showConfirmButton: false,
                timer: 8000
              });
            } else {
              self.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: error,
                showConfirmButton: false,
                timer: 5000
              });
            }
          });
      }
    },
    returnBack() {
      this.$router.push({ path: "/administration/users" });
    },
    validateData() {
      this.clearErrors()
      let dateFrom = new Date(this.dateDebut)
      let dateTo = new Date(this.dateFin)
      let regEmail = this.$store.getters.getRegMail
      let regAlpha = this.$store.getters.getRegAlpha
      let valid = true

      if (this.nom === "") {
        this.errors.nom = "Le nom est obligatoire";
        valid = false;
      } else if (!regAlpha.test(this.nom)) {
        valid = false
        this.errors.nom  = 'Veuillez entrer un nom valide'
      }
      if (this.prenom === "") {
        this.errors.prenom = "Le prénom est obligatoire";
        valid = false;
      } else if (!regAlpha.test(this.prenom)) {
        valid = false
        this.errors.prenom  = 'Veuillez entrer un prénom valide'
      }
      if (this.email === "") {
        this.errors.email = "L'adresse email est obligatoire";
        valid = false;
      } else if (!regEmail.test(this.email.trim())) {
         valid = false
         this.errors.email  = 'Veuillez entrer une adresse mail valide'
      }
      if (this.selectedStructure === "") {
        this.errors.structure = "La structure est obligatoire";
        valid = false;
      }
      if (this.selectedProfil === "") {
        this.errors.profil = "Le profil est obligatoire";
        valid = false;
      }
      if (this.dateDebut === null || this.dateDebut === "") {
        this.errors.dateDebut = "La date de début est obligatoire";
        valid= false;
      }

      if (this.dateFin !== null && this.dateFin !== "") {
        if (dateTo.getTime() < dateFrom.getTime()) {
          this.errors.dateFin = "La date de fin doit être postérieure à la date de début"
          valid= false;
        }
      }
      return valid;
    },
    clearErrors() {
      this.errors.nom = ""
      this.errors.prenom = ""
      this.errors.email = ""
      this.errors.structure = ""
      this.errors.profil = ""
      this.errors.nsi_numero_user = ""
      this.errors.nsi_numero_acteur = ""
      this.errors.dateDebut = ''
      this.errors.dateFin = ''
    }
  }
};
</script>

<style>
</style>
